<template>
  <Container type="card-full" drankColor>
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">手机</div>
          <div class="field">
            <el-input v-model.trim="query.usercode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">姓名</div>
          <div class="field">
            <el-input v-model.trim="query.username" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="640" flexname="" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true" :total="query.total" :isOperate="true"
            :operateBtn="operateBtn" @vggridClick="vggridClick"
            @pagechange="pagechange">
    </vggrid>
    <user-com-rel-dialog :visible.sync="comRelVisible" :user-id="comRelUserId" :cosid="query.cosid"></user-com-rel-dialog>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import vggrid from '../common/vggrid'
  import userComRelDialog from './userComRelDialog'
  import { getUserList } from '@/api/usercomrel'
  export default {
    name: 'userComRelIndex',
    data () {
      return {
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'username', fieldtype: 'C', title: '姓名',calculExpr:'',addNewRowFlg: false},
          { field: 'usercode', fieldtype: 'C',title: '账号',calculExpr:'',addNewRowFlg: false},
          { field: 'usermobile', fieldtype: 'C',title: '手机',calculExpr:'',addNewRowFlg: false},
          { field: 'dptname', fieldtype: 'C', title: '部门',calculExpr:'',addNewRowFlg: false},
          { field: 'usertel', fieldtype: 'C',title: '电话',calculExpr:'',addNewRowFlg: false},
          { field: 'userstateDesc', fieldtype: 'C',title: '状态',calculExpr:'',addNewRowFlg: false}
        ],
        comRelVisible: false,
        comRelUserId: 0,
        operateBtn: [
          { btncode: 'COMREL', btnname: '关联采购单位', btnicon: 'el-icon-office-building' }
        ],
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          comid: this.$store.getters.loginUser.usercomid,
          userid: this.$store.getters.loginUser.userid,
          comtype: this.$store.getters.loginUser.comtype,
          usercode: '',
          username: '',
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    activated () {
      this.getPageList()
    },
    components: {vggrid, userComRelDialog},
    methods: {
      vggridClick (code, row) {
        if (code === 'COMREL') {
          this.openComRel(row)
        }
      },
      openComRel (row) {
        if (!row.userid) {
          this.$message.warning('请先选择一个用户!')
          return
        }
        this.comRelUserId = row.userid
        this.comRelVisible = true
      },
      async pagechange (userPage) {
        this.query.offset = userPage.pageSize * (userPage.currentPage - 1)
        this.query.limit = userPage.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      // 注：用户列表走自写接口 /xtgl/usercomrel/getUserList（查当前登录单位下全部 userrec）
      async getPageList () {
        this.loading = true
        let res = await getUserList(this.query)
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    }
  }
</script>
<style lang="scss">
</style>
